export class NotFoundWebError extends Error {
    constructor(message: string, errorCode: string) {
        super(message);
        this.name = "NotFoundWebError";

        if (errorCode == "TeamRootFilesNotFound") {
            this.message += " Please try reloading Content Connector shortly.";
        }

        // Known issue with typescript, fixes instanceof not working for custom errors
        Object.setPrototypeOf(this, NotFoundWebError.prototype);
    }
}
